// 'react-dom' should only be used within this package. All other packages should import through this package
// eslint-disable-next-line no-restricted-imports
export {
    unmountComponentAtNode,
    createPortal,
    unstable_batchedUpdates,
    unstable_renderSubtreeIntoContainer,
    version,
    hydrate,
    findDOMNode,
} from 'react-dom';
export { render } from './render';
